import React, { useEffect, useState } from 'react';

export function MoneyInput({
  value,
  onChange,
  prefix = '',       // ex: "R$" ou vazio
  className,
  ...rest
}) {
  const [cents, setCents] = useState('');

  // sincroniza quando o value externo mudar
  useEffect(() => {
    if (value === '' || value == null) {
      setCents('');
      return;
    }

    const num = Number(value);
    if (isNaN(num)) return;

    const newCents = String(Math.round(num * 100));
    setCents((prev) => (prev === newCents ? prev : newCents));
  }, [value]);

  const handleChange = (e) => {
    // pega só dígitos, ignora R$, vírgula, ponto etc
    const onlyDigits = e.target.value.replace(/\D/g, '');

    if (!onlyDigits) {
      setCents('');
      onChange && onChange(''); // mantém compatível com input controlado
      return;
    }

    setCents(onlyDigits);

    // transforma centavos em valor com ponto (pra usar em cálculos)
    const numeric = (Number(onlyDigits) / 100).toFixed(2); // "12.34"
    onChange && onChange(numeric);
  };

  const formatted =
    !cents
      ? ''
      : (Number(cents) / 100).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  const displayValue = prefix && formatted
    ? `${prefix} ${formatted}`
    : formatted;

  return (
    <input
      type="text"
      className={className}
      value={displayValue}
      onChange={handleChange}
      {...rest}
    />
  );
}
